import { render, staticRenderFns } from "./list.vue?vue&type=template&id=1c148b49&scoped=true"
import script from "./list.vue?vue&type=script&lang=js"
export * from "./list.vue?vue&type=script&lang=js"
import style0 from "./list.vue?vue&type=style&index=0&id=1c148b49&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c148b49",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\www\\mer-copy\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1c148b49')) {
      api.createRecord('1c148b49', component.options)
    } else {
      api.reload('1c148b49', component.options)
    }
    module.hot.accept("./list.vue?vue&type=template&id=1c148b49&scoped=true", function () {
      api.rerender('1c148b49', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/staff/user/list.vue"
export default component.exports